import Navbar from "../components/Navbar";

export default function Bingo() {
    
    return (
      <div>
        <Navbar />
        <p className="text-center font-artistic">Bingo</p>
        <div className="grid grid-cols-5 grid-rows-5 border border-black m-5">
            <p>50 2025 albums</p>
            <p>1 week phone detox</p>
            <p>renovare Gradistea</p>
            <p>cursa semimaraton 21KM</p>
            <p>journaling minim 50 de zile</p>
            <p>scurtmetraj</p>
            <p>100 day no porn streak</p>
            <p>70 kg</p>
            <p>1 cantec la chitara</p>
            <p>learn to snowboard</p>
            <p>plantat un copac</p>
            <p>12 carti</p>
            <p>invatat o limba noua</p>
            <p>60000 moners in cont</p>
            <p>cursuri de dans</p>
            <p>1 concert/festival</p>
            <p>V6</p>
            <p>1 cantec la pian</p>
            <p>1 tara noua</p>
            <p>telefon nou</p>
            <p>craft 3 things</p>
            <p>host a DnD campaign</p>
            <p>outdoor bloudering/lead</p>
            <p>cook 10 vegetarian recipes</p>
            <p>Putin dies</p>
        </div>
      </div>
    );
  }
  